// Initialize Application Insights when your app starts
// Add this to your main App.tsx or index.tsx

import { initAppInsights, setMinLogLevel } from './appInsights';
import { getMinLogLevelForEnvironment } from './appInsightsConfig';

// Call this once when your app starts
export const setupApplicationInsights = () => {
  // Only initialize if connection string is available
  if (window.config?.APPLICATION_INSIGHTS_CONNECTION_STRING) {
    initAppInsights();
    
    // Set minimum log level based on environment
    const minLevel = getMinLogLevelForEnvironment();
    setMinLogLevel(minLevel as any); // Cast needed due to enum/number mismatch
    
    // const env = (window.config?.APP_ENV || window.config?.ENVIRONMENT_NAME || 'development');
    // console.log(`Application Insights initialized for ${env} with minimum log level: ${minLevel}`);
  } else {
    // console.warn('Application Insights connection string not found - exception tracking disabled');
  }
};

// Export for easy use
export default setupApplicationInsights;